import { enumToOptions } from '@libs/types/src/common/enum/util';
import { ContactTypeEnum } from '../../../../../../../../types/src/common/enum/contact-type.enum';

export const contactTypeEnumOptions = enumToOptions(
    ContactTypeEnum,
    'enum.contactType.',
);
